let question;
function vueQuestion() {
  question = Vue.createApp({
    delimiters: ['#{', '}'],
    setup() {
      const vehicleSearch = window.vehicleSearch();
      const storeSelector = window.storeSelector();
      const collection = window.collectionStore();
      const stock = window.stock();
      const fitmentStore = window.fitmentStore();
      const compareStore = window.compareStore();
      const promoStore = window.promo();
      if (!promoStore._timerStarted) {
          promoStore._timerStarted = true;
          setInterval(() => { promoStore.currentTime = Date.now(); }, 1000);
      }
      const cartTools = window.cartTools();

      const questions = Vue.ref([]);
      const urgency = Vue.ref(false);
      const displayProds = Vue.ref(false);
      const regoSearchLoading = Vue.ref(false);
      const displayedQuestion = Vue.ref(false);
      const questionIndex = Vue.ref(false);
      const allAnswered = Vue.ref(false);
      const locInput = Vue.ref('');
      const showStoreList = Vue.ref(false);
      const dispSuburbs = Vue.ref(false);
      const dispPostcodes = Vue.ref(false);
      const urgencySelectable = Vue.ref(false);
      const optionsSelected = Vue.ref(false);
      const activePickerId = Vue.ref(null);
      const pickerQuantities = Vue.reactive({});
      const cartEnquiringId = Vue.ref(null);
      const cartAddingId = Vue.ref(null);
      const cartSuccessId = Vue.ref(null);
      const loading = Vue.ref(true);
      const splitQuantities = Vue.reactive({});
      const force = Vue.ref(false);
      const sideFilters = Vue.ref(false);
      const selectedFilters = Vue.ref([]);
      const isFilterDrawerOpen = Vue.ref(false);
      const checkedLoad = Vue.ref(false);
      const filtersLoading = Vue.ref(true);
      const expandedFilters = Vue.reactive({});
      const watchCatcher = Vue.ref(true);
      const filtLoading = Vue.ref(false);

      const vehicleSelected = Vue.computed(() => vehicleSearch?.vehicles?.length > 0 ? true : false);
      const locationSelected = Vue.computed(() => storeSelector?.location ? true : false);
      const storeSelected = Vue.computed(() => storeSelector?.nearestStore ? true : false);
      const chosenVehicle = Vue.computed(() => vehicleSearch?.vehicles?.length > 0 ? vehicleSearch.vehicles[0] : false);
      const questionsAnswered = Vue.computed(() => questions?.value?.length > 0 && questions?.value?.every((question) => question?.answered) ? true : false);
      const urgencySelected = Vue.computed(() => urgency.value ? true : false);
      const regoInput = Vue.computed(() => vehicleSearch.regoLPN ? vehicleSearch.regoLPN : '');
      const regoStateInput = Vue.computed(() => vehicleSearch.regoState ? vehicleSearch.regoState : '');
      const regoSearchDisabled = Vue.computed(() => regoInput.value.length > 0 && regoStateInput.value.length > 0 ? false : true);
      const confirmationVehicle = Vue.computed(() => {
        const call = vehicleSearch.vehicleCall;
        if (!call || typeof call !== 'object' || call.status === 'pending') return false;
        return call;
      });
      const showSuburbs = Vue.computed(() => dispSuburbs.value.length > 0 ? true : false);
      const showPostcodes = Vue.computed(() => dispPostcodes.value.length > 0 ? true : false);
      const displayProducts = Vue.computed(() => collection.products);
      const productsExist = Vue.computed(() => displayProducts?.value?.length > 0 ? true : false);
      const selectedFitment = Vue.ref(fitmentStore?.selectedFitment || null);

      const questionObject = Vue.ref([
        {
          "key": "all_terrain",
          "value": ["All-Terrain Tyre", "All-Terrain Tyre - M+S", "All-Terrain Tyre - 3PMSF", "All-Terrain Tyre – M+S", "All-Terrain Tyre – 3PMSF, M+S"]
        },
        {
          "key": "commercial",
          "value": ["Light Commercial & Utes Tyre", "Truck", "Trailer Tyre"]
        },
        {
          "key": "driving_style",
          "value": ["Highway Tyre", "Highway Tyre - Eco - M+S", "Highway Tyre - M+S", "Highway Tyre - 3PMSF", "Highway Tyre - Eco"]
        },
        {
          "key": "everyday",
          "value": ["Everyday Driving Tyre", "Everyday Driving Tyre - Eco", "Everyday Driving Tyre - M+S", "Everyday Driving Tyre (Eco)"]
        },
        {
          "key": "key",
          "value": "driving_style"
        },
        {
          "key": "labels",
          "value": ["All-Terrain=all_terrain", "Commercial=commercial", "Highway=driving_style", "Everyday=everyday", "Mud=mud", "Performance=performance", "Spare=spare"]
        },
        {
          "key": "mud",
          "value": ["Mud Terrain Tyre", "Mud Terrain Tyre - M+S", "Mud Terrain Tyre - 3PMSF", "Mud Terrain Tyre – M+S"]
        },
        {
          "key": "namespace",
          "value": "wheel_tyre_spec"
        },
        {
          "key": "performance",
          "value": ["Sport Performance Tyre", "Sport Performance Tyre - 3PMSF", "Sport Performance Tyre – EV SUV"]
        },
        {
          "key": "snow",
          "value": ["All-Terrain Tyre - 3PMSF", "All-Terrain Tyre – 3PMSF, M+S", "Highway Tyre - 3PMSF", "Mud Terrain Tyre - 3PMSF", "Sport Performance Tyre - 3PMSF"]
        },
        {
          "key": "question",
          "value": "What kind of driving style do you most commonly use your car for?"
        },
        {
          "key": "spare",
          "value": ["Spare"]
        }
      ])

      const displayedFilterValues = (filter) => {
        if (!filter?.values) return []
        if (isFilterExpanded(filter.id)) return filter.values
        return filter.values.slice(0, 5)
      }

      const clearAllFilters = () => {
        selectedFilters.value = [];
      };

      const toggleFilterDrawer = () => {
        isFilterDrawerOpen.value = !isFilterDrawerOpen.value;
      }

      const isFilterExpanded = (id) => {
        return !!expandedFilters[id]
      }

      const toggleFilterExpansion = (id) => {
        expandedFilters[id] = !expandedFilters[id]
      }

      const regoSearch = () => {
        regoSearchLoading.value = true;
        if (regoInput.value && regoStateInput.value) {
          try {
            grecaptcha.execute();
          } catch (e) {
            regoSearchLoading.value = false;
          }
        } else {
          regoSearchLoading.value = false;
        }
      }

      const showSearchBox = () => {
        storeSelector.getLocationInfo().then(([postcodes, suburbs]) => {
          Vue.watch(locInput, (newInput, oldInput) => {
            showStoreList.value = false
            if (newInput.length < oldInput.length) {
              dispSuburbs.value = false
              dispPostcodes.value = false
            }
            storeSelector.inputListener(newInput, dispSuburbs, dispPostcodes, postcodes, suburbs)
          })
        })
      }

      const locationSelect = (locName, locLat, locLong) => {
        storeSelector.locationSelect(locName, locLat, locLong);
        dispSuburbs.value = false;
        dispPostcodes.value = false;
        showStoreList.value = true;
      }

      const chooseStore = (index) => {
        storeSelector.storeSelect(index);
        showStoreList.value = false;
        locInput.value = '';
      }

      const getQuestion = (questionObject) => {
        let idx = questionObject.findIndex(field => field.key == 'labels')
        if (idx > -1) {
          try {
            let labelArray = questionObject[idx].value;
            let options = labelArray.flatMap((label) => {
              let splitLabel = label.split('=')
              let optIdx = questionObject.findIndex(field => field.key == splitLabel[1])
              if (optIdx > -1) {
                try {
                  let values = questionObject[optIdx].value;
                  return {
                    optionName: splitLabel[0],
                    optionValues: values,
                    selected: false
                  }
                } catch (e) {
                  return []
                }
              } else {
                return [];
              }
            })
            let kIdx = questionObject.findIndex(field => field.key == 'key');
            let nIdx = questionObject.findIndex(field => field.key == 'namespace');
            let qIdx = questionObject.findIndex(field => field.key == 'question');
            if (kIdx > -1 && nIdx > -1 && qIdx > -1) {
              return {
                question: questionObject[qIdx].value,
                namespace: questionObject[nIdx].value,
                key: questionObject[kIdx].value,
                options: options,
                answered: false,
                answerTitle: false,
                answerValues: []
              }
            }
          } catch (e) {
            console.log(`Option not found: ${e}`)
          }
        }
      }

      const toggleAnswer = (questionIndex, optionIndex) => {
        if (questions?.value[questionIndex]?.options[optionIndex]) {
          questions.value[questionIndex].options[optionIndex].selected = !questions.value[questionIndex].options[optionIndex].selected
        }
        if (questions?.value[questionIndex]?.options.findIndex(o => o.selected) > -1) {
          optionsSelected.value = true;
        } else {
          optionsSelected.value = false;
        }
      }

      const confirmVehicle = (response) => {
        if (response) {
          vehicleSearch.addVehicle(confirmationVehicle.value);
        } else {
          vehicleSearch.vehicleCall = false;
        }
        regoSearchLoading.value = false;
      }

      const genericQuery = async (queryString) => {
        const options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
          },
          body: JSON.stringify({ query: queryString })
        };
        const response = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
        const object = await response.json()
        if (object?.errors) {
          return object.errors;
        }
        if (object) {
          return object
        } else {
          return [{ message: "Unknown error" }];
        }
      }

      /*const metaObjectQuery = async (id) => {
        if (!id.includes("gid://shopify/Metaobject/")) {
          id = `gid://shopify/Metaobject/${id}`
        }
        let queryString = `{
          metaobject(id:"${id}") {
            fields {		
              key
              value
            }		
          }
        }`
        try {
          let metaObjectDetails = await genericQuery(queryString);
          return metaObjectDetails.data.metaobject;
        } catch (e) {
          if (typeof e === 'object' && e.length > 0) {
            for (let i = 0; i < e.length; i++) {
              throw new Error(e[i].message);
            }
          } else {
            throw new Error(e);
          }
        }
      }*/

      const configureHandle = (fitment, axle, prodType) => {
        let searchHandle
        if (fitment?.[`${axle}_${prodType}`]?.matches?.length > 0) {
          let val = fitment[`${axle}_${prodType}`].matches[0].split('_')[0].split('R')[1].toString();
          searchHandle = val;
        }
        if (searchHandle) {
          if (searchHandle.includes('.')) {
            searchHandle = searchHandle.replaceAll('.', '-');
          }
          return searchHandle;
        } else {
          return false;
        }
      }

      const queryFilters = (fitment, runFlat, electric, axle, prodType, answered) => {
        let filters
        if (fitment?.[`${axle}_${prodType}`]?.matches?.length > 0) {
          for (let i = 0; i < fitment[`${axle}_${prodType}`].matches.length; i++) {
            if (filters) {
              filters = `${filters},{productMetafield:{namespace:"wts",key:"sf",value:"${fitment[`${axle}_${prodType}`].matches[i]}"}}`
            } else {
              filters = `{productMetafield:{namespace:"wts",key:"sf",value:"${fitment[`${axle}_${prodType}`].matches[i]}"}}`
            }
          }
        }
        if (filters) {
          filters = `${filters},{productMetafield:{namespace:"tyre_spec",key:"run_flat",value:"${runFlat}"}},{productMetafield:{namespace:"tyre_spec",key:"ev_tyre",value:"${electric}"}}`
        }
        if (answered.length > 0) {
          let answerFilters
          for (let i = 0; i < answered.length; i++) {
            for (let z = 0; z < answered[i].answerValues.length; z++) {
              if (answerFilters) {
                answerFilters = `${answerFilters},{productMetafield:{namespace:"${answered[i].namespace}",key:"${answered[i].key}",value:"${answered[i].answerValues[z]}"}}`
              } else {
                answerFilters = `{productMetafield:{namespace:"${answered[i].namespace}",key:"${answered[i].key}",value:"${answered[i].answerValues[z]}"}}`
              }
            }
          }
          if (filters && answerFilters) {
            filters = `${filters},${answerFilters}`
          } else if (answerFilters) {
            filters = answerFilters;
          }
        }
        return filters;
      }

      const getFilters = async (fitment, runFlat, electric, axle, prodType, answered) => {
        let filters = queryFilters(fitment, runFlat, electric, axle, prodType, answered);
        if (!filters) {
          throw new Error("Unable to configure filters")
        }
        let handle = configureHandle(fitment, axle, prodType);
        if (!handle) {
          throw new Error("Unable to configure handle")
        }
        let sideBarFilters = getSideBarFilters();
        if (filters) {
          filters = `${filters},${sideBarFilters}`
        } else {
          filters = sideBarFilters
        }
        let queryString = `{
	        collection(handle:"${handle}") {
		        products(first:1, filters:[${filters}]) {
			        filters {
				        id
                label
				        values {
					        id
					        input
					        label
					        count
				        }
			        }
		        }
	        }
        }`
        try {
          let filterDetails = await genericQuery(queryString);
          if (filterDetails?.data?.collection?.products?.filters) {
            return filterDetails.data.collection.products.filters;
          } else {
            new Error("Error retrieving filters")
          }
        } catch (e) {
          if (typeof e === 'object' && e.length > 0) {
            for (let i = 0; i < e.length; i++) {
              throw new Error(e[i].message)
            }
          } else {
            throw new Error(e);
          }
        }
      }

      const getSideBarFilters = () => {
        let mappedFilters = selectedFilters.value.flatMap((filt) => {
          try {
            let jFilt = JSON.parse(filt);
            let outerEntry = Object?.keys(jFilt)?.[0] || false;
            if (outerEntry) {
              if (typeof jFilt[outerEntry] === 'object') {
                let entries = Object.entries(jFilt[outerEntry]);
                let entryString
                for (let i = 0; i < entries.length; i++) {
                  if (i === 0) {
                    entryString = `${entries[i][0]}:"${entries[i][1]}"`;
                  } else {
                    entryString = `${entryString},${entries[i][0]}:"${entries[i][1]}"`;
                  }
                }
                return `{${outerEntry}:{${entryString}}}`;
              } else {
                return `{${outerEntry}:"${jFilt[outerEntry]}"}`
              }
            } else {
              return [];
            }
          } catch (e) {
            return [];
          }
        })
        let string = ''
        for (let i = 0; i < mappedFilters.length; i++) {
          if (i === 0) {
            string = mappedFilters;
          } else {
            string = `${string},${mappedFilters}`;
          }
        }
        return string;
      }

      const getProducts = async (fitment, runFlat, electric, axle, prodType, sortKey, reverse, answered) => {
        let filters = queryFilters(fitment, runFlat, electric, axle, prodType, answered);
        if (!filters) {
          throw new Error("Unable to configure filters");
        }
        let handle = configureHandle(fitment, axle, prodType);
        if (!handle) {
          new Error("Unable to configure handle");
        }
        let splitString = '';
        if (fitment.is_split) {
          splitString = `metafield(namespace:"wts",key:"sf") {
  					value
  				}`
        }
        let sideBarFilters = getSideBarFilters();
        if (filters) {
          filters = `${filters},${sideBarFilters}`
        } else {
          filters = sideBarFilters
        }
        let queryString = `{
	        collection(handle:"${handle}") {
		        products(first:100, sortKey:${sortKey}, reverse:${reverse}, filters:[${filters}]) {
			        edges {
                node {
                  id
                  title
                  tags
                  vendor
                  handle
                  category {
                    name
                  }
                  images(first:1) {
                    edges {
                      node {
                        altText
                        height
                        width
                        url
                      }
                    }
                  }
                  ${splitString}
                  variants(first:1) {
                    edges {
                      node {
                        id
                        price {
                          amount
                        }
                      }
                    }
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                    }
                    maxVariantPrice {
                      amount
                    }
                  }
                  collections(first:50) {
                    edges {
                      node {
                        id
                        title: metafield(namespace:"promotion",key:"title") {
                          value
                        }
                        type: metafield(namespace:"promotion",key:"type") {
                          value
                        }
                        value: metafield(namespace:"promotion",key:"value") {
                          value
                        }
                        colour: metafield(namespace:"promotion",key:"colour") {
                          value
                        }
                        end_date: metafield(namespace:"promotion",key:"end_date") {
                          value
                        }
                      }
                    }
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
		        }
	        }
        }`
        try {
          let products = await genericQuery(queryString);
          if (products?.data?.collection?.products?.edges) {
            return products.data.collection.products.edges;
          } else {
            new Error("Error retrieving products")
          }
        } catch (e) {
          if (typeof e === 'object' && e.length > 0) {
            for (let i = 0; i < e.length; i++) {
              throw new Error(e[i].message);
            }
            return;
          } else {
            throw new Error(e);
          }
        }
      }

      const filterCleaner = (filters, stripFilters) => {
        filters = filters.flatMap((filter) => {
          if (stripFilters.includes(filter.id)) {
            return [];
          } else if (filter.values.every((item) => item.count === 0)) {
            return [];
          } else {
            filter.values = filter.values.flatMap((value) => {
              if (value.count > 0) {
                return value;
              } else {
                return [];
              }
            })
            if (filter.values.length > 1) {
              return filter;
            } else {
              return [];
            }
          }
        })
        return filters;
      }

      const mergeFilters = (frontFilters, rearFilters) => {
        for (let i = 0; i < rearFilters.length; i++) {
          let idx = frontFilters.findIndex(filter => filter.id == rearFilters[i].id)
          if (idx > -1) {
            for (let b = 0; b < rearFilters[i].values.length; b++) {
              let vidx = frontFilters[idx].values.findIndex(val => val.id == rearFilters[i].values[b].id)
              if (vidx > -1) {
                frontFilters[idx].values[vidx].count = frontFilters[idx].values[vidx].count + rearFilters[i].values[b].count
              } else {
                frontFilters[idx].values.push(rearFilters[i].values[b]);
              }
            }
          } else {
            frontFilters.push(rearFilters[i])
          }
        }
        return frontFilters;
      }

      const filterQuestionsByAnswersVehicle = async (vehicle) => {
        filtersLoading.value = true;
        let cleanFilters;
        if (vehicle?.fitmentInfo?.tyre_fitments?.[0]) {
          let answered = questions.value.filter(q => q?.answered)
          let filters = await getFilters(vehicle.fitmentInfo.tyre_fitments[0], vehicle.fitmentInfo.is_run_flat, vehicle.fitmentInfo.is_electric, 'f', 'tyres', answered);
          let stripFilters = ['filter.v.availability', 'filter.p.m.wts.sf', 'filter.p.m.wheel_tyre_spec.rim_diameter', 'filter.p.m.wheel_tyre_spec.width', 'filter.p.m.tyre_spec.aspect_ratio', 'filter.p.m.tyre_spec.run_flat', 'filter.p.tag']
          cleanFilters = filterCleaner(filters, stripFilters);
          sideFilters.value = cleanFilters.flatMap((filt) => {
            let idx = questions.value.findIndex(q => filt.id.includes(q.namespace) && filt.id.includes(q.key))
            if (idx > -1) {
              return [];
            } else {
              return filt;
            }
          })
          if (sideFilters.value.length > 0) {
            filtersLoading.value = false;
          }
          if (vehicle?.fitmentInfo?.tyre_fitments?.[0].is_split) {
            let splitFilters = await getFilters(vehicle.fitmentInfo.tyre_fitments[0], vehicle.fitmentInfo.is_run_flat, vehicle.fitmentInfo.is_electric, 'r', 'tyres', answered);
            let cleanSplitFilters = filterCleaner(splitFilters, stripFilters);
            cleanFilters = mergeFilters(cleanFilters, cleanSplitFilters)
          }
        } else {
          throw new Error("Error: no fitments found for this vehicle");
        }
        if (cleanFilters) {
          let spliceList = [];
          for (let i = 0; i < questions.value.length; i++) {
            if (questions?.value?.[i]?.answered) {
              continue;
            }
            let idx = cleanFilters.findIndex(filter => filter.id.replaceAll('filter.p.m.', '') == `${questions.value[i].namespace}.${questions.value[i].key}`)
            if (idx === -1) {
              spliceList.push(i);
              continue;
            }
            let options = [];
            for (let t = 0; t < questions.value[i].options.length; t++) {
              let optionCount = 0;
              for (let z = 0; z < questions.value[i].options[t].optionValues.length; z++) {
                let vidx = cleanFilters[idx].values.findIndex(val => val.label == questions.value[i].options[t].optionValues[z])
                if (vidx === -1) {
                  continue;
                } else {
                  optionCount = optionCount + cleanFilters[idx].values[vidx].count;
                }
              }
              if (optionCount > 0) {
                options.push(questions.value[i].options[t])
              }
            }
            if (options.length > 1) {
              questions.value[i].options = options;
            } else {
              spliceList.push(i);
            }
          }
          for (let i = spliceList.length - 1; i > -1; i--) {
            questions.value.splice(spliceList[i], 1);
          }
          const prom = new Promise((resolve) => {
            resolve(questions.value)
          })
          return prom;
        } else {
          throw new Error("Error: no questions found for this vehicle");
        }
      }

      const reloadProducts = (answered) => {
        getProducts(chosenVehicle.value.fitmentInfo.tyre_fitments[0], chosenVehicle.value.fitmentInfo.is_run_flat, chosenVehicle.value.fitmentInfo.is_electric, 'f', 'tyres', 'BEST_SELLING', false, answered)
          .then(object => {
            collection.products = object;
          })
          .then(() => {
            if (chosenVehicle.value.fitmentInfo.tyre_fitments[0].is_split) {
              getProducts(chosenVehicle.value.fitmentInfo.tyre_fitments[0], chosenVehicle.value.fitmentInfo.is_run_flat, chosenVehicle.value.fitmentInfo.is_electric, 'r', 'tyres', 'BEST_SELLING', false, answered)
                .then(object => {
                  let splitProducts = object;
                  collection.products = collection.products.flatMap((product) => {
                    product.node.fits = 'FRONT';
                    let idx = product?.node?.tags?.findIndex(tag => tag.toLowerCase().includes('product:'))
                    if (idx > -1) {
                      let prodTag = product.node.tags[idx];
                      let splitMatches = splitProducts.filter(prod => prod?.node?.tags?.includes(prodTag));
                      if (splitMatches.length > 0) {
                        let returnArray = [];
                        for (let i = 0; i < splitMatches.length; i++) {
                          splitMatches[i].node.is_split = true;
                          splitMatches[i].node.fits = 'REAR';
                          product.node.is_split = true;
                          product.node.splitProduct = splitMatches[i];
                          product.node = promoStore.calculatePromoValues(product.node);
                          returnArray.push(product);
                        }
                        if (returnArray.length > 0) {
                          return returnArray;
                        } else {
                          product.node.is_split = false;
                          product.node.splitProduct = false;
                          product.node = promoStore.calculatePromoValues(product.node);
                          return product;
                        }
                      } else {
                        product.node.is_split = false;
                        product.node.splitProduct = false;
                        product.node = promoStore.calculatePromoValues(product.node);
                        return product;
                      }
                    } else {
                      product.node.is_split = false;
                      product.node.splitProduct = false;
                      product.node = promoStore.calculatePromoValues(product.node);
                      return product;
                    }
                  })
                  let filteredSplits = splitProducts?.filter(prod => collection?.products?.findIndex(p => p?.node?.splitProduct?.node?.id == prod?.node?.id) === -1)
                  if (filteredSplits.length > 0) {
                    for (let i = 0; i < filteredSplits.length; i++) {
                      filteredSplits[i].node.fits = 'REAR';
                      filteredSplits[i].node.is_split = false;
                      filteredSplits[i].node.splitProduct = false;
                      collection.products.push(filteredSplits[i]);
                    }
                  }
                })
            } else {
              collection.products = collection.products.flatMap((product) => {
                product.node = promoStore.calculatePromoValues(product.node);
                return product;
              })
            }
          }).then(() => {
            if (!displayedQuestion.value && storeSelected.value) {
              let qty = 4;
              if (vehicleSelected?.value?.fitmentInfo?.tyre_fitments?.[0]?.is_split) {
                qty = 2;
              }
              stock.PLPStockRequest(qty).then(() => {
                loading.value = false;
                filtLoading.value = false;
                let idx = collection?.products?.findIndex(prod => prod?.node?.stock?.qtyInStore > 3)
                if (idx > -1) {
                  urgencySelectable.value = true;
                }
              })
            } else {
              loading.value = false;
              filtLoading.value = false;
            }
          })
          .catch(() => {
            loading.value = false;
            filtLoading.value = false;
          })
      }

      const answerQuestion = async (idx) => {
        loading.value = true;
        optionsSelected.value = false;
        questions.value[idx].answered = true;
        questions.value[idx].answerValues = questions.value[idx].options.flatMap((option) => {
          if (option.selected) {
            return option.optionValues
          } else {
            return [];
          }
        });
        localStorage.setItem('questionnaire', JSON.stringify(questions.value))
        let qidx = questions.value.findIndex(q => !q?.answered)
        if (qidx > -1) {
          let question = questions.value[qidx]
          displayedQuestion.value = question;
          questionIndex.value = qidx;
        } else {
          displayedQuestion.value = false;
          questionIndex.value = false;
        }
        try {
          questions.value = await filterQuestionsByAnswersVehicle(chosenVehicle.value)
        } catch (e) {
          console.error(e);
        }
        let answered = questions.value.filter(q => q?.answered)
        reloadProducts(answered);
      }

      const getSelectedVehicleForSelection = () => {
        const activeVehicleId = localStorage.getItem('activeVehicleId')
        const liveVehicles = Array.isArray(vehicleSearch.vehicles) ? vehicleSearch.vehicles : []
        let storedVehicles
        try {
          storedVehicles = JSON.parse(localStorage.getItem('vehicles') || '[]')
        } catch (e) {
          storedVehicles = []
        }
        if (!activeVehicleId) {
          return null
        }

        const liveMatch = liveVehicles.find(v => String(v?.id) === String(activeVehicleId))
        if (liveMatch) return liveMatch

        return storedVehicles.find(v => String(v?.id) === String(activeVehicleId)) || null
      }

      const getActiveVehicle = () => {
        const selectedVehicle = getSelectedVehicleForSelection()
        if (selectedVehicle) return selectedVehicle
        return null
      }

      const vehicleName = Vue.computed(() => {
        const activeVehicle = getActiveVehicle()
        return activeVehicle?.make?.display_name && activeVehicle?.model?.display_name
          ? `${activeVehicle.make.display_name} ${activeVehicle.model.display_name}`
          : false
      })

      const vehicleMakeName = Vue.computed(() => {
        const activeVehicle = getActiveVehicle()
        return activeVehicle?.make?.display_name
          ? `${activeVehicle.make.display_name}`
          : false
      })

      const vehicleLogo = Vue.computed(() => getActiveVehicle()?.logo_url || null)

      const vehicleFitmentUnavailable = Vue.computed(() => {
        const fitment = chosenVehicle.value?.fitmentInfo?.tyre_fitments?.[0];
        if (!fitment) return false;
        return !(fitment?.f_tyres?.matches?.length > 0);
      })

      const getActiveFitment = () => {
        const vehicle = getActiveVehicle()
        if (!vehicle) return null

        if (selectedFitment.value) {
          const frontLabel = selectedFitment.value.fullSize || selectedFitment.value.size || ''
          const rearLabel = selectedFitment.value.fullRearSize || selectedFitment.value.rearSize || ''
          if (selectedFitment.value.isSplit) {
            return {
              isSplit: true,
              front: frontLabel,
              rear: rearLabel
            }
          }
          return {
            isSplit: false,
            single: frontLabel
          }
        }

        const preferredFitment = chosenVehicle.fitmentInfo?.tyre_fitments?.[0] || null
        if (!preferredFitment) return null

        const frontNode = preferredFitment.f_tyres
        const rearNode = preferredFitment.r_tyres

        if (preferredFitment.is_split) {
          return {
            isSplit: true,
            front: getFitmentLabel(frontNode),
            rear: getFitmentLabel(rearNode)
          }
        }
        return {
          isSplit: false,
          single: getFitmentLabel(frontNode)
        }
      }

      const fitmentDisplay = (productNode) => {
        const fitment = getActiveFitment()
        if (!fitment) {
          return {
            frontSize: '',
            rearSize: '',
            frontPrice: '',
            rearPrice: ''
          }
        }

        if (fitment.isSplit) {
          if (productNode?.is_split && productNode?.splitProduct?.node) {
            return splitFitmentDisplay(productNode)
          }
          const basePrice = productNode?.priceRange?.minVariantPrice?.amount
          if (productNode?.fits === 'REAR') {
            return {
              frontSize: fitment.front || '',
              rearSize: fitment.rear || '',
              frontPrice: 'Not available',
              rearPrice: promoStore.priceFormat(basePrice),
              rearAvailable: true
            }
          }
          return {
            frontSize: fitment.front || '',
            rearSize: fitment.rear || '',
            frontPrice: promoStore.priceFormat(basePrice),
            rearPrice: '',
            rearAvailable: false
          }
        }

        const basePrice = productNode?.priceRange?.minVariantPrice?.amount
        return {
          frontSize: fitment.single || '',
          rearSize: '',
          frontPrice: promoStore.priceFormat(basePrice),
          rearPrice: '',
          rearAvailable: false
        }
      }

      const getCollectionProductType = () => {
        return 'tyre'
      }

      const getStockStatus = (productNode) => {
        const stock = productNode?.stock;
        if (!stock || typeof stock !== 'object' || Array.isArray(stock)) return 'loading';
        if (stock.available == null) return 'loading';
        const available = String(stock.available).trim().toUpperCase();
        if (available === 'Y' || available === 'L' || stock.available === true) return 'in';
        if (available === 'N' || stock.available === false) return 'out';
        return 'loading';
      };

      const ensureSplitQty = (productNode) => {
        const key = productNode?.id
        if (!key) return null
        if (!splitQuantities[key]) {
          splitQuantities[key] = { front: 2, rear: 2 }
        }
        return splitQuantities[key]
      }

      const updateSplitQty = async (productNode, axle, delta) => {
        const entry = ensureSplitQty(productNode)
        if (!entry) return
        const current = axle === 'rear' ? entry.rear : entry.front
        const nextValue = Math.max(0, current + delta)
        let nearbyLocations = [];
        if (localStorage.getItem('storesUnder100')) {
          try {
            let parsedStores = JSON.parse(localStorage.getItem('storesUnder100'));
            nearbyLocations = nearbyLocations.concat(parsedStores);
          } catch (err) {
            console.error(`Error retrieving nearby stores: ${err}`)
          }
        }
        let requestLocations = nearbyLocations.map(location => location.node.id.replaceAll("gid://shopify/Location/", ""));
        requestLocations.unshift(storeSelector.nearestStore.node.id.replaceAll("gid://shopify/Location/", ""))
        if (axle === 'rear') {
          entry.rear = nextValue;
          if (nextValue > 0) {
            let stockUpdate = await stock.requestStock([productNode.splitProduct.node.id.replaceAll("gid://shopify/Product/", "")], requestLocations, nextValue, true);
            const locStock = stockUpdate?.[0]?.locations?.[0];
            productNode.splitProduct.node.stock.leadDays = locStock?.availableDays;
            productNode.splitProduct.node.stock.available = locStock?.available;
          }
        } else {
          entry.front = nextValue;
          if (nextValue > 0) {
            let stockUpdate = await stock.requestStock([productNode.id.replaceAll("gid://shopify/Product/", "")], requestLocations, nextValue, true);
            const locStock = stockUpdate?.[0]?.locations?.[0];
            productNode.stock.leadDays = locStock?.availableDays;
            productNode.stock.available = locStock?.available;
          }
        }
      }

      const getSplitStockStatus = (productNode, axle) => {
        if (!productNode) return 'loading';
        const isRear = axle === 'rear';
        const splitNode = productNode?.splitProduct?.node || null;

        if (!splitNode) {
          const baseStatus = getStockStatus(productNode);
          if (productNode?.fits === 'REAR') {
            return isRear ? baseStatus : 'out';
          }
          return isRear ? 'out' : baseStatus;
        }

        const frontNode = productNode?.fits === 'REAR' ? splitNode : productNode;
        const rearNode = productNode?.fits === 'REAR' ? productNode : splitNode;
        const targetNode = isRear ? rearNode : frontNode;
        return getStockStatus(targetNode);
      };

      const splitFitmentDisplay = (productNode) => {
        const fitment = getActiveFitment()
        if (!fitment?.isSplit) return null
        if (!productNode?.is_split || !productNode?.splitProduct?.node) return null

        const basePrice = productNode?.priceRange?.minVariantPrice?.amount
        const splitPrice = productNode?.splitProduct?.node?.priceRange?.minVariantPrice?.amount

        let frontPrice = basePrice
        let rearPrice = splitPrice
        if (productNode?.fits === 'REAR') {
          frontPrice = splitPrice
          rearPrice = basePrice
        }

        return {
          frontSize: fitment.front,
          rearSize: fitment.rear,
          frontPrice: promoStore.priceFormat(frontPrice),
          rearPrice: promoStore.priceFormat(rearPrice),
          rearAvailable: true
        }
      }

      const isCartEnquiring = (productNode) => cartEnquiringId.value === productNode?.id

      const isPickerOpen = (productNode) => {
        if (!productNode?.id) return false
        return activePickerId.value === productNode.id
      }

      const closeQuantityPicker = () => {
        activePickerId.value = null
      }

      const getPickerQty = (productNode) => {
        const key = productNode?.id
        if (!key) return 1
        if (!pickerQuantities[key]) {
          const flip = productNode?.stock?.flip
          let defaultQty = 4
          if (Array.isArray(flip) && flip.length > 0) {
            for (let i = Math.min(3, flip.length - 1); i >= 0; i--) {
              if (getFlipSlotStatus(productNode, i) === 'nearest') {
                defaultQty = i + 1
                break
              }
            }
          }
          pickerQuantities[key] = defaultQty
        }
        return pickerQuantities[key]
      }

      const setPickerQty = (productNode, qty) => {
        const key = productNode?.id
        if (!key) return
        pickerQuantities[key] = qty
      }

      const getNearestStoreName = () => {
        let store
        try {
          const storeSelector = window.storeSelector ? window.storeSelector() : null
          store = storeSelector?.nearestStore || null
        } catch (e) { }
        try {
          const raw = localStorage.getItem('currentNearestStore')
          store = raw ? JSON.parse(raw) : null
        } catch (e) { }
        const node = store?.node || store
        return node?.name || 'selected store'
      }

      const storeLink = (storeName) => {
        return `${shopifyConfig.storeURL}/pages/${storeName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}-t-marts`
      }

      const hasNearestStore = () => {
        try {
          const ss = window.storeSelector ? window.storeSelector() : null
          if (ss?.nearestStore) return true
        } catch (e) { }
        try {
          const raw = localStorage.getItem('currentNearestStore')
          return !!JSON.parse(raw)
        } catch (e) { }
        return false
      }

      const openStoreSelector = () => {
        const btn = document.getElementById('my-store-btn')
        if (btn) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); btn.click() }
      }

      const isVehicleSplit = () => !!getActiveFitment()?.isSplit

      const getSplitStock = (productNode, axle) => getSplitNodeByAxle(productNode, axle)?.stock

      const getFlipSlotNearbyStoreName = (productNode, slotIndex) => {
        const flip = productNode?.stock?.flip;
        if (!Array.isArray(flip) || flip.length <= slotIndex) return 'a nearby store';
        const locationGid = flip[slotIndex]?.nearestStore;
        if (!locationGid) return 'a nearby store';

        try {
          const stores = JSON.parse(localStorage.getItem('storesUnder100') || '[]');
          const match = stores.find(s => {
            const id = String(s?.node?.id || '').replace('gid://shopify/Location/', '');
            return id === String(locationGid);
          });
          if (match?.node?.name) return match.node.name;
        } catch (e) { }

        return 'a nearby store';
      };

      const getFlipSlotLeadTime = (productNode, slotIndex) => {
        const flip = productNode?.stock?.flip;
        if (!Array.isArray(flip) || flip.length <= slotIndex) return null;
        return flip[slotIndex]?.leadTimeDays ?? null;
      };

      const getFlipSlotPrice = (productNode, slotIndex) => {
        const flip = productNode?.stock?.flip;
        if (!Array.isArray(flip) || flip.length <= slotIndex) return null;
        return flip[slotIndex]?.pricePerUnit ?? null;
      };

      const getFlipSlotStatus = (productNode, slotIndex) => {
        const flip = productNode?.stock?.flip;
        if (!Array.isArray(flip) || flip.length <= slotIndex) return 'none';
        const slot = flip[slotIndex];
        if (!slot) return 'none';
        if (slot.selectedAvailable === true) return 'nearest';
        if (slot.nearestStore !== false && slot.nearestStore != null) return 'nearby';
        return 'none';
      };

      const getSplitNodeByAxle = (productNode, axle) => {
        if (!productNode) return null;
        const isRear = axle === 'rear';
        const splitNode = productNode?.splitProduct?.node || null;

        if (!splitNode) {
          if (productNode?.fits === 'REAR') {
            return isRear ? productNode : null;
          }
          return isRear ? null : productNode;
        }

        const frontNode = productNode?.fits === 'REAR' ? splitNode : productNode;
        const rearNode = productNode?.fits === 'REAR' ? productNode : splitNode;
        return isRear ? rearNode : frontNode;
      };

      const normalizeCompareId = (value) => String(value || '').replace('gid://shopify/Product/', '');

      const isInCompare = (product) => {
        const productId = product.id || product.node?.id;
        if (!productId) return false;
        const normalizedProductId = normalizeCompareId(productId);
        return (compareStore.selectedProducts || []).some(p =>
          normalizeCompareId(p.id || p.node?.id) === normalizedProductId
        );
      };

      const toggleCompare = (product) => {
        // Check if product already exists
        const productId = product.id || product.node?.id;
        const normalizedProductId = normalizeCompareId(productId);
        const existingIndex = (compareStore.selectedProducts || []).findIndex(p =>
          normalizeCompareId(p.id || p.node?.id) === normalizedProductId
        );

        if (existingIndex > -1) {
          // Product already in compare - remove it
          compareStore.selectedProducts.splice(existingIndex, 1);
          compareStore?.persist?.();

          // Close drawer if no products left
          if (compareStore.selectedProducts.length === 0) {
            compareStore.isDrawerOpen = false;
            compareStore?.persist?.();
          }
          return;
        }


        if (compareStore.selectedProducts.length >= 3) {
          console.warn("Max 3 products allowed");
          compareStore?.showCompareLimitDialog?.("You can only compare up to 3 tyres");
          return;
        }

        // Add product to store
        compareStore.selectedProducts.push({
          id: productId,
          title: product.title,
          price: product.priceRange.minVariantPrice.amount,
          featured_image: product.images?.edges[0]?.node?.url || defaultTyreImage,
          vendor: product.vendor,
          available: product.availableForSale
        });

        // Open the drawer
        compareStore?.openCompareDrawer?.();
      };

      const getProductTitleFromTags = (productNode) => {
        const tags = productNode?.tags
        if (!Array.isArray(tags)) return productNode?.title || ''
        const tag = tags.find((t) => typeof t === 'string' && /^product\s*:/i.test(t))
        if (!tag) return productNode?.title || ''
        return tag.replace(/^product\s*:\s*/i, '').trim()
      }

      const getProductUrl = (productNode) => {
        const base = `/products/${productNode.handle}`
        if (!productNode?.is_split || !productNode?.splitProduct?.node) {
          if (productNode?.fits === 'REAR' && productNode?.handle) {
            const rearHandle = encodeURIComponent(productNode.handle)
            return `/products/${productNode.handle}?r=${rearHandle}`
          }
          if (productNode?.fits === 'FRONT' && productNode?.handle) {
            const frontHandle = encodeURIComponent(productNode.handle)
            return `/products/${productNode.handle}?f=${frontHandle}&r=none`
          }
          return base
        }

        const frontNode = getSplitNodeByAxle(productNode, 'front')
        const rearNode = getSplitNodeByAxle(productNode, 'rear')

        if (!frontNode?.handle) return base
        const frontHandle = encodeURIComponent(frontNode.handle)
        if (!rearNode?.handle) return `/products/${frontNode.handle}?f=${frontHandle}&r=none`

        const rearHandle = encodeURIComponent(rearNode.handle)
        return `/products/${frontNode.handle}?f=${frontHandle}&r=${rearHandle}`
      }

      const getLabelTags = (productNode) => {
        const tags = productNode?.tags
        if (!Array.isArray(tags)) return []
        return tags
          .filter((tag) => typeof tag === 'string' && /^label\s*:/i.test(tag))
          .map((tag) => tag.replace(/^label\s*:\s*/i, '').trim())
          .filter(Boolean)
      }

      const isStockLoading = (productNode) => {
        const stock = productNode?.stock;
        if (!stock || typeof stock !== 'object' || Array.isArray(stock)) return true;
        if (stock.available == null) return true;
        return false;
      };

      const sendEnquiry = (node, split) => {
        if (split) {
          localStorage.setItem('storeEnquiry', JSON.stringify(
            {
              title: node.title || "",
              sku: node.tags.filter(tag => tag.includes('sku:'))[0].replaceAll('sku:', '') || "",
              splitTitle: split.title || "",
              splitSku: split.tags.filter(tag => tag.includes('sku:'))[0].replaceAll('sku:', '') || ""
            }
          ))
        } else {
          localStorage.setItem('storeEnquiry', JSON.stringify(
            {
              title: node.title || "",
              sku: node.tags.filter(tag => tag.includes('sku:'))[0].replaceAll('sku:', '') || ""
            }
          ))
        }

        const existingIndex = (compareStore.selectedProducts || []).findIndex(p =>
          normalizeCompareId(p.id || p.node?.id) === normalizeCompareId(node.id)
        );

        if (existingIndex == -1) {
          if (compareStore.selectedProducts.length >= 3) {
            compareStore.selectedProducts.splice(0, 1);
          }

          // Add product to store
          compareStore.selectedProducts.push({
            id: node.id,
            title: node.title,
            price: node.priceRange.minVariantPrice.amount,
            featured_image: node.images?.edges[0]?.node?.url || defaultTyreImage,
            vendor: node.vendor,
            available: node.availableForSale
          });
          compareStore.persist();
        }
        cartEnquiringId.value = node?.id;
        window.location.href = `${shopifyConfig.storeURL}/pages/${shopifyConfig.contactDefault}`;
      };

      const openQuantityPicker = (productNode) => {
        if (!productNode?.id) return
        if (getStockStatus(productNode) === 'out') {
          const flip = productNode?.stock?.flip
          const hasFlipAvailability = Array.isArray(flip) && flip.some((_, idx) => {
            const slotStatus = getFlipSlotStatus(productNode, idx)
            return slotStatus === 'nearest' || slotStatus === 'nearby'
          })
          if (!hasFlipAvailability) {
            goToEnquiryPage()
            return
          }
        }
        if (!pickerQuantities[productNode?.id]) {
          const flip = productNode?.stock?.flip
          let defaultQty = 4
          if (Array.isArray(flip) && flip.length > 0) {
            for (let i = Math.min(3, flip.length - 1); i >= 0; i--) {
              if (getFlipSlotStatus(productNode, i) === 'nearest') {
                defaultQty = i + 1
                break
              }
            }
          }
          pickerQuantities[productNode?.id] = defaultQty
        }
        activePickerId.value = productNode.id
      }

      const isCartAdding = (productNode) => cartAddingId.value === productNode?.id
      const isCartSuccess = (productNode) => cartSuccessId.value === productNode?.id

      const addToCartWithQty = async (productNode) => {
        if (!productNode) return
        closeQuantityPicker()
        cartAddingId.value = productNode?.id || null;
        cartSuccessId.value = null;
        const fitmentDisplayResult = splitFitmentDisplay(productNode)
        if (fitmentDisplayResult) {
          try {
            await addToCart(productNode)
            setCartSuccess(productNode)
          } catch (e) {
            cartAddingId.value = null;
            cartSuccessId.value = null;
          }
          return
        }
        const qty = getPickerQty(productNode)
        if (getFlipSlotStatus(productNode, qty - 1) === 'none') {
          cartAddingId.value = null
          return
        }
        const variantId = getVariantId(productNode?.variants?.edges[0]?.node?.id)
        let basePromo = false;
        if (productNode?.collections.edges.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1) {
          if (productNode?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
            basePromo = true;
          }
        }
        try {
          if (variantId) {
            await addVariantToCart(variantId, qty, basePromo)
            setCartSuccess(productNode)
          } else {
            cartAddingId.value = null;
            cartSuccessId.value = null;
          }
        } catch (e) {
          cartAddingId.value = null;
          cartSuccessId.value = null;
        }
      }

      const getVariantId = (variantId) => {
        if (!variantId) return null
        if (typeof variantId === 'string' && variantId.includes('/')) {
          return variantId.split('/').pop()
        }
        return variantId
      }

      const setCartSuccess = (productNode) => {
        cartAddingId.value = null
        cartSuccessId.value = productNode?.id || null
        if (cartSuccessTimer) clearTimeout(cartSuccessTimer)
        cartSuccessTimer = setTimeout(() => {
          cartSuccessId.value = null
        }, 2500)
      }

      const getSplitQty = (productNode, axle) => {
        const entry = ensureSplitQty(productNode)
        if (!entry) return 0
        return axle === 'rear' ? entry.rear : entry.front
      }

      const addToCart = async (productNode) => {
        if (!productNode) return
        if (getStockStatus(productNode) === 'out') {
          goToEnquiryPage()
          return
        }
        const fitmentDisplay = splitFitmentDisplay(productNode)
        let basePromo = false;
        if (productNode?.collections.edges.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1) {
          if (productNode?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
            basePromo = true;
          }
        }
        if (fitmentDisplay) {
          const frontQty = getSplitQty(productNode, 'front')
          const rearQty = getSplitQty(productNode, 'rear')
          const baseVariantId = getVariantId(productNode?.variants?.edges?.[0]?.node?.id)
          const splitVariantId = getVariantId(productNode?.splitProduct?.node?.variants?.edges?.[0]?.node?.id)
          let splitPromo = false;
          if (productNode?.splitProduct?.node?.collections.edges.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1) {
            if (productNode?.splitProduct?.node?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
              splitPromo = true;
            }
          }
          if (productNode?.fits === 'REAR') {
            if (splitVariantId && frontQty > 0) await addVariantToCart(splitVariantId, frontQty, splitPromo)
            if (baseVariantId && rearQty > 0) await addVariantToCart(baseVariantId, rearQty, basePromo)
          } else {
            if (baseVariantId && frontQty > 0) await addVariantToCart(baseVariantId, frontQty, basePromo)
            if (splitVariantId && rearQty > 0) await addVariantToCart(splitVariantId, rearQty, splitPromo)
          }
          return
        }
        const variantId = getVariantId(productNode?.variants?.edges?.[0]?.node?.id)
        if (variantId) {
          await addVariantToCart(variantId, 1, basePromo)
        }
      }

      const addVariantToCart = async (variantId, qty, promo) => {
        if (!cartTools || !variantId || !qty) return
        const cartId = getCartId(cartTools)
        try {
          if (cartId) {
            await cartTools.cartAdd(variantId, qty, cartId, promo)
          } else {
            await cartTools.newCart(variantId, qty, vehicleSearch.vehicles, storeSelector.location, promo)
          }
        } catch (e) {
          await cartTools.newCart(variantId, qty, vehicleSearch.vehicles, storeSelector.location, promo)
        }
        cartTools.openCheckout = false
        cartTools.showCart = true
      }

      const getCartId = (cartTools) => {
        if (!cartTools) return null
        const cartData = cartTools.cartData?.value || cartTools.cartData || null
        if (cartData?.id) return cartData.id
        try {
          const raw = localStorage.getItem('cartData')
          const parsed = raw ? JSON.parse(raw) : null
          return parsed?.id || null
        } catch (e) { }
        return null
      }

      const goToEnquiryPage = () => {
        const url = (typeof window.getEnquiryPageUrl === 'function')
          ? window.getEnquiryPageUrl()
          : `${String(shopifyConfig?.storeURL || window.location.origin || '').replace(/\/$/, '')}/pages/contact`
        window.location.href = url
      }

      const clearAnswers = () => {
        loading.value = true;
        let question = getQuestion(questionObject.value);
        let idx = questions.value.findIndex(q => q.question == question.question && q.namespace == question.namespace && q.key == question.key)
        if (idx > -1) {
          questions.value[idx] = question;
        }
        localStorage.removeItem('questionnaire');
        setQuestion();
      }

      const setQuestion = () => {
        if (vehicleSelected.value && vehicleFitmentUnavailable.value) {
          displayedQuestion.value = false;
          questionIndex.value = false;
          loading.value = false;
          filtLoading.value = false;
          return;
        }
        let qidx = questions.value.findIndex(q => !q?.answered)
        if (qidx > -1) {
          let question = questions.value[qidx]
          displayedQuestion.value = question;
          questionIndex.value = qidx;
        } else {
          displayedQuestion.value = false;
          questionIndex.value = false;
        }
        if (vehicleSelected.value) {
          filterQuestionsByAnswersVehicle(chosenVehicle.value)
            .then(object => {
              questions.value = object;
              loading.value = false;
            })
            .catch((e) => {
              console.error(e);
              loading.value = false;
            });
          if (locationSelected.value && !displayedQuestion.value) {
            let answered = questions.value.filter(q => q?.answered)
            reloadProducts(answered);
          }
        } else {
          loading.value = false;
        }
      }

      const availabilityString = (node) => {
        if (!node?.stock?.leadDays) return 'Available'
        if (node?.stock?.leadDays === 0) {
          return 'Available Now'
        } else if (node?.stock?.leadDays === 1) {
          return 'Get it Tomorrow';
        } else if (node?.stock?.leadDays < 7) {
          let parsedLead = Date.parse(new Date()) + node?.stock?.leadDays * 24 * 60 * 60 * 1000;
          let day = new Date(parsedLead).toLocaleDateString('en-AU', { weekday: 'long' })
          if (day == 'Sunday') {
            return 'Get it by Monday'
          }
          return `Get it by ${day}`;
        } else {
          return `Get it in ${node?.stock?.leadDays} days`;
        }
      }

      Vue.watch(chosenVehicle, (newVehicle) => {
        if (newVehicle?.fitmentInfo) {
          if (vehicleFitmentUnavailable.value) {
            displayedQuestion.value = false;
            questionIndex.value = false;
            loading.value = false;
            filtLoading.value = false;
            return;
          }
          filterQuestionsByAnswersVehicle(newVehicle)
            .then(object => {
              questions.value = object;
            })
            .catch((e) => {
              console.error(e);
            });
          if (locationSelected.value && !displayedQuestion.value) {
            let answered = questions.value.filter(q => q?.answered)
            reloadProducts(answered);
          }
        }
      })

      Vue.watch(storeSelected, () => {
        if (storeSelected.value && chosenVehicle.value && !displayedQuestion.value) {
          let answered = questions.value.filter(q => q?.answered)
          reloadProducts(answered);
        }
      })

      /*Vue.watch(questions, (newQuestions) => {
        /*console.log(questions)
        console.log(questions.value)
        if (questions?.value?.filter(q => q?.answered).length != newQuestions?.filter(q => q?.answered).length) {
          reloadingProducts.value = true;
          let qidx = newQuestions.findIndex(q => !q?.answered)
          if (qidx > -1) {
            let question = newQuestions[qidx]
            displayedQuestion.value = question;
            questionIndex.value = qidx;
          } else {
            displayedQuestion.value = false;
            questionIndex.value = false;
          }
          getProducts(chosenVehicle.value.fitmentInfo.tyre_fitments[0], chosenVehicle.value.fitmentInfo.is_run_flat, 'f', 'tyres', 'BEST_SELLING', false)
            .then(object => {
              collection.products = object;
            })
            .then(() => {
              if (chosenVehicle.value.fitmentInfo.is_split) {
                getProducts(chosenVehicle.value.fitmentInfo.tyre_fitments[0], chosenVehicle.value.fitmentInfo.is_run_flat, 'r', 'tyres', 'BEST_SELLING', false)
                  .then(object => {
                    let splitProducts = object;
                    collection.products = collection.products.flatMap((product) => {
                      product.node.fits = 'FRONT';
                      let idx = product?.node?.tags?.findIndex(tag => tag.toLowerCase().includes('product:'))
                      if (idx > -1) {
                        let prodTag = product.node.tags[idx];
                        let splitMatches = splitProducts.filter(prod => prod?.node?.tags?.includes(prodTag));
                        if (splitMatches.length > 0) {
                          let returnArray = [];
                          for (let i = 0; i < splitMatches.length; i++) {
                            splitMatches[i].node.is_split = true;
                            splitMatches[i].node.fits = 'REAR';
                            product.node.is_split = true;
                            product.node.splitProduct = splitMatches[i];
                            returnArray.push(product);
                          }
                          if (returnArray.length > 0) {
                            return returnArray;
                          } else {
                            product.node.is_split = false;
                            product.node.splitProduct = false
                            return product;
                          }
                        } else {
                          product.node.is_split = false;
                          product.node.splitProduct = false
                          return product;
                        }
                      } else {
                        product.node.is_split = false;
                        product.node.splitProduct = false;
                        return product;
                      }
                    })
                    let filteredSplits = splitProducts?.filter(prod => collection?.products?.findIndex(p => p?.node?.splitProduct?.node?.id == prod?.node?.id) === -1)
                    if (filteredSplits.length > 0) {
                      for (let i = 0; i < filteredSplits.length; i++) {
                        filteredSplits[i].node.fits = 'REAR';
                        filteredSplits[i].node.is_split = false;
                        filteredSplits[i].node.splitProduct = false;
                        collection.products.push(filteredSplits[i]);
                      }
                    }
                  })
              }
            })
          reloadingProducts.value = false;
          if (questionsAnswered.value && storeSelected.value) {
            reloadingStock.value = true;
            stock.PLPStockRequest().then(() => {
              reloadingStock.value = false;
            })
          }
        }
      })*/

      Vue.watch(selectedFilters, () => {
        if (watchCatcher.value) {
          watchCatcher.value = false;
          setTimeout(() => {
            filtLoading.value = true;
            let answered = questions.value.filter(q => q?.answered)
            reloadProducts(answered);
            filterQuestionsByAnswersVehicle(chosenVehicle.value);
            watchCatcher.value = true;
          }, 1500)

        }
      })

      Vue.watch(displayProducts, () => {
        if (storeSelected.value) {
          let qty = 4;
          if (vehicleSelected?.value?.fitmentInfo?.tyre_fitments?.[0]?.is_split) {
            qty = 2;
          }
          stock.PLPStockRequest(qty).then(() => {
            let enforce = displayProducts.value;
            force.value = enforce;
          })
        }
      })

      Vue.watch(questionsAnswered, (answer) => {
        if (answer) {
          allAnswered.value = true;
          displayProds.value = true;
        } else {
          allAnswered.value = false;
          displayProds.value = false;
        }
      });

      Vue.watch(regoInput, (newRego) => {
        vehicleSearch.regoLPN = newRego.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
      })

      Vue.watch(confirmationVehicle, (newConfVehicle) => {
        if (newConfVehicle && !newConfVehicle?.fitmentInfo && newConfVehicle?.id) {
          vehicleSearch.getFitment(newConfVehicle.id).then(fitment => {
            if (fitment == 'fitFail') {
              throw new Error("Error retrieving fitments");
            } else {
              if (!fitment?.tyre_fitments?.[0]?.is_oe) {
                let idx = fitment?.tyre_fitments.findIndex(fit => fit.is_oe)
                if (idx > -1) {
                  fitment.tyre_fitments.unshift(fitment.tyre_fitments.splice(idx, 1)[0])
                }
              }
              vehicleSearch.vehicleCall.fitmentInfo = fitment;
              vehicleSearch.vehicleCall.fitmentInfo.version = vehicleSearch.releaseVersion;
              vehicleSearch.vehicleCall.fitmentInfo.expiry = Date.parse(new Date()) + 24 * (60 * 60 * 1000);
              vehicleSearch.vehicleCall.manufactureYear = vehicleSearch.manYear(vehicleSearch.vehicleCall);
              vehicleSearch.vehicleCall.rego = vehicleSearch.regoLPN;
              vehicleSearch.vehicleCall.regoState = vehicleSearch.regoState;
              delete vehicleSearch.vehicleCall.ip;
            }
          })
        }
      })

      Vue.onMounted(() => {
        let question = getQuestion(questionObject.value);
        questions.value.push(question)
        if (localStorage.getItem('questionnaire')) {
          try {
            let localQuestions = JSON.parse(localStorage.getItem('questionnaire'))
            questions.value = questions.value.flatMap((q) => {
              let idx = localQuestions.findIndex(lq => lq.question == q.question && lq.answered)
              if (idx > -1) {
                q = localQuestions[idx];
              }
              return q;
            })
          } catch (e) {
          }
        }
        setQuestion();
      });

      return {
        vehicleSelected,
        locationSelected,
        storeSelected,
        questions,
        answerQuestion,
        questionsAnswered,
        regoSearchDisabled,
        regoSearchLoading,
        regoSearch,
        confirmationVehicle,
        confirmVehicle,
        vehicleSearch,
        displayedQuestion,
        questionIndex,
        locInput,
        showStoreList,
        showSearchBox,
        dispPostcodes,
        dispPostcodes,
        locationSelect,
        storeSelector,
        showSuburbs,
        showPostcodes,
        chooseStore,
        urgencySelectable,
        displayProducts,
        toggleAnswer,
        optionsSelected,
        productsExist,
        splitFitmentDisplay,
        isPickerOpen,
        closeQuantityPicker,
        getPickerQty,
        getFlipSlotStatus,
        setPickerQty,
        getNearestStoreName,
        storeLink,
        getFlipSlotNearbyStoreName,
        getFlipSlotLeadTime,
        getFlipSlotPrice,
        getProductUrl,
        isInCompare,
        toggleCompare,
        getLabelTags,
        getProductTitleFromTags,
        fitmentDisplay,
        getCollectionProductType,
        getStockStatus,
        updateSplitQty,
        isStockLoading,
        isCartAdding,
        isCartSuccess,
        isCartEnquiring,
        isStockLoading,
        getActiveFitment,
        vehicleName,
        vehicleMakeName,
        vehicleLogo,
        vehicleFitmentUnavailable,
        promoStore,
        openQuantityPicker,
        sendEnquiry,
        loading,
        getSplitStockStatus,
        addToCartWithQty,
        getSplitQty,
        getSplitNodeByAxle,
        ensureSplitQty,
        isFilterDrawerOpen,
        sideFilters,
        toggleFilterDrawer,
        checkedLoad,
        filtersLoading,
        isFilterExpanded,
        toggleFilterExpansion,
        clearAllFilters,
        displayedFilterValues,
        selectedFilters,
        filtLoading,
        clearAnswers,
        availabilityString,
        isVehicleSplit,
        hasNearestStore,
        openStoreSelector,
        getSplitStock,
        defaultTyreImage: window.defaultTyreImage
      };
    },
  })

  if (window.VueAppGlobals?.pinia) question.use(window.VueAppGlobals.pinia);
  question.mount('#question');
}

if (window.Vue && window.Pinia) {
  vueQuestion();
} else {
  window.addEventListener('vue-ready', vueQuestion);
}